import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/upload',
  component: DashBoardNav,
  children: [
    {
      path: '/upload',
      component: () => import('@/components/upload/UploadManager')
    },
    {
      path: '/ConfigTable',
      name: 'config-table',
      component: () => import('@/components/upload/ConfigTable'),
      props: true
    },
    {
      path: '/ConfigStatus',
      name: 'config-status',
      component: () => import('@/components/upload/ConfigStatus')
    },
    {
      path: '/ImportWizard',
      name: 'import-wizard',
      component: () => import('@/components/upload/ImportWizard')
    }
  ]
}]
